import { useCallback, useState } from 'react'
// import { isMobile } from 'react-device-detect'

export const useRoverFocus = size => {
  const [currentFocus, setCurrentFocus] = useState(0)

  const handleKeyDown = useCallback(
    e => {
      if (e.keyCode === 40) {
        // Down arrow
        e.preventDefault()
        setCurrentFocus(currentFocus === size - 1 ? size - 1 : currentFocus + 1)
      } else if (e.keyCode === 38) {
        // Up arrow
        e.preventDefault()
        setCurrentFocus(currentFocus === 0 ? 0 : currentFocus - 1)
      } else if (e.key === 'Enter' || e.key === 'Escape') {
        e.target.blur()
      }
    },
    [size, currentFocus, setCurrentFocus],
  )

  const handleClick = useCallback(
    index => {
      setCurrentFocus(index)
    },
    [size, currentFocus, setCurrentFocus],
  )

  //   useEffect(() => {
  //     document.addEventListener('keydown', handleKeyDown, false)
  //     return () => {
  //       document.removeEventListener('keydown', handleKeyDown, false)
  //     }
  //   }, [handleKeyDown])

  return { focus: currentFocus, handleKeyDown, handleClick }
}
